var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNobillinghistoryicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2626_1167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9466 28.0107C56.0959 31.5733 55.8061 35.1406 55.0836 38.6324C53.1099 47.9504 47.1335 53.9451 36.9525 55.2488C30.2363 56.2373 23.398 56.0259 16.7558 54.6245C13.7989 54.038 11.0349 52.7236 8.71381 50.8001C6.39277 48.8765 4.58795 46.4047 3.46264 43.6081C1.76166 39.4785 0.915334 35.047 0.974774 30.5812C0.784157 26.321 1.07363 22.0528 1.83772 17.8573C3.80231 9.13596 8.19969 4.28875 17.123 2.14055C24.5826 0.332055 32.3663 0.332055 39.8259 2.14055C48.7676 4.28875 53.1925 9.15432 55.0836 17.8481C55.8334 21.1804 56.1238 24.5997 55.9466 28.0107Z",
    fill: "#D7F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.52 15.6487C37.1283 15.6487 36 19.0065 36 23.1487H38.52C39.7345 23.1487 40.3417 23.1487 40.7176 22.7294C41.0936 22.31 41.0281 21.7578 40.8973 20.6534C40.5518 17.738 39.6179 15.6487 38.52 15.6487Z",
    fill: "#83D2DA",
    stroke: "#007E8C",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 36.4559V23.2165C36 20.6939 36.5 15.6487 38.5 15.6487H23.5C19.9645 15.6487 18.1967 15.6487 17.0984 16.757C16 17.8652 16 19.649 16 23.2165V36.4559C16 38.3456 16 39.2903 16.5774 39.6622C17.5211 40.2701 18.9799 38.9954 19.7136 38.5328C20.3687 38.1197 20.6771 37.9363 21.0407 37.9483C21.3771 37.9593 21.6802 38.1504 22.2864 38.5328L24.675 40.0392L24.6759 40.0398C25.3196 40.4456 25.6417 40.6487 26 40.6487C26.3582 40.6487 26.6802 40.4457 27.3236 40.0401L27.325 40.0392L29.7136 38.5328C30.3686 38.1197 30.6771 37.9363 31.0406 37.9483C31.3771 37.9593 31.6801 38.1504 32.2862 38.5327L32.2864 38.5328C33.0201 38.9954 34.4789 40.2701 35.4225 39.6622C36 39.2903 36 38.3456 36 36.4559Z",
    fill: "#007E8C",
    stroke: "#007E8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 20.6487H31",
    stroke: "#D7F9FD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 25.6487H21",
    stroke: "#D7F9FD",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.125 26.7424C28.0895 26.7424 27.25 27.4769 27.25 28.3831C27.25 29.2892 28.0895 30.0237 29.125 30.0237C30.1605 30.0237 31 30.7582 31 31.6643C31 32.5704 30.1605 33.3049 29.125 33.3049M29.125 26.7424C29.9414 26.7424 30.6359 27.1989 30.8933 27.8362M29.125 26.7424V25.6487M29.125 33.3049C28.3086 33.3049 27.6141 32.8484 27.3567 32.2112M29.125 33.3049V34.3987",
    stroke: "#D7F9FD",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2626_1167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNobillinghistoryicon);
export default __webpack_public_path__ + "static/media/no billing history icon.d90131c8aa40f7d6c0e2b83ac45bbbce.svg";
export { ForwardRef as ReactComponent };